class PushLogicAjaxHandler {
	constructor() {
	  this.secureToken = null;
	  this.tokenExpiry = 0;
	  this.tokenEndpoint = this.getEndpointUrl() + '/webhook/secure-token';
	  this.fetchSecureToken();
	  this.initAjaxSetup();
	  // Refresh the token every 4 minutes (adjust as needed)
	  setInterval(() => { this.fetchSecureToken(); }, 4 * 60 * 1000);
	}

	getEndpointUrl() {
	  const host = window.location.host;
	  const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
	  const live_endpoint = 'https://shopify.treasuretrails.co.uk';

	  if (host === 'treasure-trails-dev.myshopify.com') {
		return dev_endpoint;
	  } else if (host === 'treasuretrails.co.uk') {
		return live_endpoint;
	  } else {
		return live_endpoint;
	  }
	}

	fetchSecureToken() {
	  return fetch(this.tokenEndpoint)
		.then(response => {
		  if (!response.ok) throw new Error('Failed to fetch secure token');
		  return response.json();
		})
		.then(data => {
		  // Assume the returned JSON has { signature: "...", timestamp: 1234567890 }
		  this.secureToken = data;
		  // Assume token is valid for 5 minutes:
		  this.tokenExpiry = Date.now() + (5 * 60 * 1000);
		  return data;
		})
		.catch(err => {
		  console.error("Error fetching secure token:", err);
		});
	}

	initAjaxSetup() {
	  const self = this;
	  $.ajaxSetup({
		beforeSend: function (jqXHR, settings) {
		  // Add secure token only for URLs containing "/webhook/" or "/checkout/"
		  if (settings.url.indexOf('/webhook/') !== -1 || settings.url.indexOf('/checkout/') !== -1) {
			if (self.secureToken && Date.now() < self.tokenExpiry) {
			  jqXHR.setRequestHeader('X-Signature', self.secureToken.signature);
			  // If sending JSON data, update (or add) the timestamp property with the secure token's timestamp.
			  if (settings.data && settings.contentType && settings.contentType.indexOf('application/json') !== -1) {
				try {
				  let payload = JSON.parse(settings.data);
				  payload.timestamp = self.secureToken.timestamp;
				  settings.data = JSON.stringify(payload);
				} catch (e) {
				  console.error("Error updating payload timestamp:", e);
				}
			  }
			}
		  }
		}
	  });
	}
}

// Instantiate the handler on document ready.
jQuery(document).ready(function($) {
	if (window.__PushLogicAjaxHandlerInitialized) return;
	new PushLogicAjaxHandler();
	window.__PushLogicAjaxHandlerInitialized = true;
});

class PushLogic_Fruitbowl
{
	constructor()
  	{
    	this.map_instructions();
		this.lets_get_digging();
    }

	getEndpointUrl()
	{
		const host = window.location.host;
		const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
		const live_endpoint = 'https://shopify.treasuretrails.co.uk';
		
		if(host == 'treasure-trails-dev.myshopify.com')
		{
			return dev_endpoint;
		} else if(host == 'treasuretrails.co.uk') {
			return live_endpoint;
		} else {
			return live_endpoint;
		}
	}
	
	map_instructions()
	{
		var challenges = $('.fb-container.challenge');
		
		if(challenges.length > 0)
		{
			$.each(challenges, function(index, value)
			{
				
				// Declare Vars
				
				var challenge_block = $(this),
					challenge_form = challenge_block.find('form'),
					correct_answer = challenge_block.find('.answer-correct'),
					incorrect_answer = challenge_block.find('.answer-incorrect'),
					show_me = challenge_block.find('.showme'),
					hide_me = challenge_block.find('.hideme');
					
				// First, lets hide the clues
				
				correct_answer.hide();
				incorrect_answer.hide();
				
				// Let's disable the anchor reveals and handle it ourselves to ensure form data doesn't get wiped between answers
				
				$(show_me).on('click', function(e)
				{
					var reveal_button = $(this),
						reveal_block = reveal_button.closest('div').find('div').first();
						
					e.preventDefault();
					reveal_button.hide();
					$('html, body').animate({
						scrollTop: $('#' + reveal_button.attr('id')).offset().top+1
					}, 500);
					reveal_block.slideDown();
				});
				
				$(hide_me).on('click', function(e)
				{
					var reveal_button = $(this),
						reveal_block = reveal_button.closest('div');
					
					e.preventDefault();
					reveal_block.slideUp(function()
					{
						show_me.show();
					});
				});
				
				// Now, lets handle the form behaviour
				
				$(challenge_form).on('submit', function(e)
				{
					
					// Declare Vars
					
					var form = $(this),
						selected_answer = form.find('select option:selected'),
						form_answer = form.find('input[name="challenge_answer"]');
						
					// Prevent Default Form Submit Behaviour

					e.preventDefault();
					
					// Show / Hide Correct / Incorrect Clues
					
					if(selected_answer.val() == form_answer.val())
					{
						correct_answer.show();
						incorrect_answer.hide();
					} else {
						incorrect_answer.show();
						correct_answer.hide();
					}
				});
			});
		}
	}
	
	lets_get_digging()
	{
		// Declare Vars
		
		var self = this,
			form = $('#fruitbowl-submit-data');
		
		// If form exists
		
		if(form.length > 0)
		{
			// Declare Vars
			
			var correct = $('#correct'),
				incorrect = $('#incorrect');
				
			// Hide Results
				
			correct.hide();
			incorrect.hide();
			
			// Form Handler
				
			$(form).on('submit', function(e)
			{
				// Declare Vars
				
				var current_form = $(this),
					access_key = '29C3AD22A98A9FEE1AEEBD1CD24C3',
					name = current_form.find('input[name="name"]').val(),
					email = current_form.find('input[name="email"]').val(),
					selected_answer = current_form.find('select option:selected').val(),
					theme = current_form.find('input[name="theme"]').val(),
					campaign = current_form.find('input[name="campaign"]').val(),
					correct_answer = current_form.find('input[name="correct_answer"]').val();
					
				// Prevent Default Form Submit Behaviour
				
				e.preventDefault();
				
				// Show / Hide Correct / Incorrect Result
				
				if(selected_answer == correct_answer)
				{
					correct.show();
					incorrect.hide();
					var answer_correct = 'Yes';
					$('html, body').animate({
						scrollTop: $('#correct').offset().top+1
					}, 500);
				} else {
					incorrect.show();
					correct.hide();
					var answer_correct = 'No';
					$('html, body').animate({
						scrollTop: $('#incorrect').offset().top+1
					}, 500);
				}
				
				var data = {
					name : name, 
					email : email, 
					selected_answer : selected_answer, 
					theme : theme, 
					campaign : campaign,
					answer_correct : answer_correct,
					access_key : access_key
				};
				
				self.send_data_to_app(data);
				
			});
		}
	}
  
  	popup_message(text)
  	{
		var popup = '<div id="pltt-form-popup-outer"><div id="pltt-form-popup-inner"><div id="pltt-form-popup"><span id="pltt-form-popup-close">x</span>' + text + '</div></div></div></div>';
		$(popup).appendTo('body');
		$('#pltt-form-popup-close').on('click', function()
		{
			$('#pltt-form-popup-outer').fadeOut(function()
			{
				$('#pltt-form-popup-outer').remove();
			});
		});
    }
	
	send_data_to_app(submission)
	{
		var self             = this,
			webhook_endpoint = self.getEndpointUrl() + '/webhook/fruitbowl-submissions';
			
		$.ajax({

			type: 'POST',
			url: webhook_endpoint,
			crossDomain: true,
			data: JSON.stringify(submission),
			dataType: 'json',
			contentType: 'application/json',

			success : function(data)
			{
				console.log('Submission Successful');
			},

			error: function (jqXHR, exception)
			{
				var error = '';

				if (jqXHR.status === 0) {
					error = 'Can\'t connect.\n Verify Network.';
				} else if (jqXHR.status == 404) {
					error = 'Requested page not found (404).';
				} else if (jqXHR.status == 500) {
					error = 'Internal Server Error (500).';
				} else if (jqXHR.status == 401) {
					error = 'Request Unauthorized (401).';
				} else if (exception === 'parsererror') {
					error = 'Requested JSON parse failed.';
				} else if (exception === 'timeout') {
					error = 'Time out error.';
				} else if (exception === 'abort') {
					error = 'Ajax request aborted.';
				} else {
					error = 'Uncaught Error.\n' + jqXHR.responseText;
				}

				console.error(error);
				
				self.popup_message('<p>There was an issue submitting your data. Please click on the submission button again. If this continues please feel free to get in touch with our Customer Services team. Thank you.</p>');
			},
		});
	}
}

window.addEventListener('load', function () {
    new PushLogic_Fruitbowl;
});